/**
 * Composable para obter o nome customizado do assistente IA
 * Usado em toda a plataforma para substituir "Captain/Capitão"
 *
 * Uso:
 * import { useAgentName } from 'dashboard/composables/useAgentName';
 * const { agentName } = useAgentName();
 */

import { computed } from 'vue';

// Default fallback - usado quando AGENT_NAME não está configurado ou está vazio
const DEFAULT_AI_ASSISTANT_NAME = 'Agent Assistant';

/**
 * Retorna o nome customizado do assistente IA de forma reativa
 * Protege contra undefined, null e strings vazias
 *
 * @returns {Object} Objeto com computed property agentName
 */
export function useAgentName() {
  const agentName = computed(() => {
    const configuredName = window.globalConfig?.AGENT_NAME;

    // Verifica se existe e não é string vazia (após trim)
    if (configuredName && typeof configuredName === 'string') {
      const trimmedName = configuredName.trim();
      if (trimmedName.length > 0) {
        return trimmedName;
      }
    }

    return DEFAULT_AI_ASSISTANT_NAME;
  });

  return {
    agentName,
  };
}
